import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getProductAccess } from "@/lib/productAccessApi";

export default function ProductAccessGate({ productSlug, productTitle, loadingLabel, children }) {
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const access = await getProductAccess(productSlug);
        if (!cancelled) setState({ loading: false, allowed: Boolean(access.allowed), access });
      } catch {
        if (!cancelled) setState({ loading: false, allowed: false });
      }
    })();
    return () => { cancelled = true; };
  }, [productSlug]);

  if (state.loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#F7F1E7] text-sm italic text-[#806B52]"
           data-testid={`product-access-loading-${productSlug}`}>
        {loadingLabel || "Проверяем доступ…"}
      </div>
    );
  }

  if (!state.allowed) {
    return (
      <main className="min-h-screen grid place-items-center bg-[#F7F1E7] px-6 text-[#3B241A]"
            data-testid={`product-access-locked-${productSlug}`}>
        <section className="max-w-lg text-center">
          <p className="text-[10px] uppercase tracking-[0.35em] opacity-60 mb-4">Anokina Studio</p>
          <h1 className="font-serif text-4xl mb-4">{productTitle}</h1>
          <p className="text-sm leading-7 opacity-80 mb-8">
            Для этого продукта нужен отдельный активный доступ.
          </p>
          <button type="button" onClick={() => nav("/hall")}
                  className="rounded-xl bg-[#2A1810] px-7 py-3 text-xs uppercase tracking-[0.22em] text-[#EFE4D0]"
                  data-testid={`product-access-back-${productSlug}`}>
            Вернуться в главный холл
          </button>
        </section>
      </main>
    );
  }

  return children;
}
